import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "flex gap-8 px-2 items-center" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src", "alt"]

import {computed, ref, watch} from "vue";
import SidebarNavigation from "./sidebarNavigation.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'sidebarIcons',
  props: {
    filter: { default: () => ({}) },
    activeValue: { default: "" },
    mode: { default: "normal" }
  },
  emits: ["update"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const itemKeys = computed(() => Object.keys(props.filter.values || {}));
const itemRefs = ref<HTMLElement[]>([]);
const scrollContainer = ref<HTMLElement | null>(null);
const manualIndex = ref(0);

const currentIndex = computed({
  get: () => manualIndex.value,
  set: (val) => {
    manualIndex.value = val;
    scrollToIndex(val);
  }
});

const scrollToIndex = (index: number) => {
  const el = itemRefs.value[index];
  if (el) {
    el.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'center'});
  }
};

const onScroll = () => {
  if (!scrollContainer.value) return;
  const container = scrollContainer.value;
  const containerCenter = container.scrollLeft + container.clientWidth / 2;

  let closestIndex = 0;
  let minDistance = Infinity;

  itemRefs.value.forEach((el, index) => {
    if (!el) return;
    const elCenter = el.offsetLeft + el.clientWidth / 2;
    const distance = Math.abs(elCenter - containerCenter);
    if (distance < minDistance) {
      minDistance = distance;
      closestIndex = index;
    }
  });

  manualIndex.value = closestIndex;
};

watch(() => props.activeValue, (newVal) => {
  const idx = itemKeys.value.indexOf(newVal?.toString() || "");
  if (idx >= 0) {
    manualIndex.value = idx;
  }
}, {immediate: true});

const getImageUrl = (value: string) => {
  if (!props.filter.image) return "";
  const processedVal = props.filter.lowercaseImage !== false ? value.toLowerCase() : value;
  return props.filter.image.replaceAll("{value}", processedVal);
};

const updateValue = (val: string) => {
  emit("update", val);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "scrollContainer",
      ref: scrollContainer,
      class: "overflow-x-auto no-scrollbar scroll-smooth",
      onScroll: onScroll
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.filter.values, (label, val, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: val,
            ref_for: true,
            ref: el => { if (el) itemRefs.value[index] = el as any },
            class: "flex flex-col justify-center items-center cursor-pointer min-w-fit",
            onClick: ($event: any) => (updateValue(val.toString()))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["overflow-hidden rounded-full flex items-center justify-center mb-2 transition-all duration-300", [
                __props.mode === 'small' ? 'w-8 h-8' : 'w-16 h-16',
                __props.activeValue === val ? (__props.mode === 'small' ? 'shadow-md w-10 h-10 border border-brand-main border-opacity-50' : 'shadow-md w-20 h-20 border border-brand-main') : ''
            ]])
            }, [
              (val.toString() !== '')
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: getImageUrl(val.toString()),
                    alt: label,
                    class: "w-full h-full object-contain",
                    style: _normalizeStyle({ transform: `scale(${0.4 + (val / 3) * 0.6})` }),
                    onError: _cache[0] || (_cache[0] = (e) => e.target.style.display = 'none')
                  }, null, 44, _hoisted_4))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["w-full h-full flex items-center justify-center", __props.mode === 'small' ? 'text-xs' : ''])
                  }, _toDisplayString(label), 3))
            ], 2),
            (val.toString() !== '')
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(["text-gray-500 tracking-wide whitespace-nowrap", [
                __props.activeValue === val ? 'font-bold' : '',
                __props.mode === 'small' ? 'text-xs' : 'text-sm'
            ]])
                }, _toDisplayString(label), 3))
              : _createCommentVNode("", true)
          ], 8, _hoisted_3))
        }), 128))
      ])
    ], 544),
    _createVNode(SidebarNavigation, {
      total: itemKeys.value.length,
      modelValue: currentIndex.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentIndex).value = $event)),
      container: scrollContainer.value
    }, null, 8, ["total", "modelValue", "container"])
  ]))
}
}

})